import React from 'react';
import { Container, Link, Typography } from '@sm/wds-react';
import { TopBarSlimThemes } from './TopBarSlimEnums';
import { TopBarSlimSkeletonLoader } from './TopBarSlimSkeleton';
import './top-bar-slim.scss';

export type TopBarSlimProps = {
  message: string;
  ctaText?: string;
  ctaLink?: string;
  theme?: TopBarSlimThemes;
  prefix?: string;
  ctaNewTab?: boolean;
  loading?: boolean;
};

export const TopBarSlim: React.FC<TopBarSlimProps> = ({
  message,
  ctaText,
  ctaLink,
  theme,
  prefix,
  ctaNewTab,
  loading,
}) => {
  const slimTheme = `sm-top-bar-slim--${theme}`;
  return (
    <>
      {loading ? (
        <TopBarSlimSkeletonLoader data-testid="loader" />
      ) : (
        <Container
          className={slimTheme}
          data-testid="theme-wrapper"
          flex
          flexDirection="row"
          flexAlign="center"
          flexJustify="center"
          p={2}
        >
          <Typography className={`${slimTheme}__text`}>
            {prefix && <strong data-testid="prefix">{prefix}</strong>} {message}
          </Typography>
          {ctaText && (
            <Link
              className="wds-m-l-1"
              href={ctaLink}
              target={ctaNewTab ? '_blank' : undefined}
            >
              <Typography className={`${slimTheme}__cta-text`}>
                {ctaText}
              </Typography>
            </Link>
          )}
        </Container>
      )}
    </>
  );
};

TopBarSlim.defaultProps = {
  theme: TopBarSlimThemes.info,
  ctaNewTab: false,
  loading: false,
};

export default TopBarSlim;
